import React, { ChangeEvent, FC, ReactNode, useState } from 'react';
import { ClickAwayListener, Grid, makeStyles, Tabs } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { LargeTab, Search } from 'components';
import { ContentApprovalTypes, SearchContentInput } from 'api';
import { UseCheckedState } from 'types/app';

interface Props extends Partial<UseCheckedState> {
  filter: SearchContentInput;
  setFilter: (filter: SearchContentInput) => void;
  actions?: ReactNode;
}

const useStyles = makeStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
  },
}));

const TableHeader: FC<Props> = ({ filter, setFilter, hasChecked, actions, resetCheckedState }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [focused, setFocused] = useState(false);

  function onChangeTabs(event: ChangeEvent<HTMLDivElement>, value: ContentApprovalTypes) {
    setFilter({ ...filter, approval: value });
    resetCheckedState();
  }

  function onChangeSearch(query: string) {
    setFilter({ ...filter, search_text: query });
  }

  function renderSearch() {
    return (
      <ClickAwayListener onClickAway={() => setFocused(false)}>
        <Search
          query={filter.search_text || ''}
          focused={focused}
          onChange={(event: ChangeEvent<HTMLInputElement>) => onChangeSearch(event.target.value)}
          onClear={() => onChangeSearch('')}
          onFocus={() => setFocused(true)}
        />
      </ClickAwayListener>
    );
  }

  return (
    <div className={classes.root}>
      <Grid container alignItems="center" spacing={2}>
        <Grid item>
          <Tabs value={filter.approval} onChange={onChangeTabs}>
            <LargeTab label={t('admin:submitted')} value={ContentApprovalTypes.Submitted} />
            <LargeTab label={t('common:scheduled')} value={ContentApprovalTypes.Scheduled} />
            <LargeTab label={t('admin:live')} value={ContentApprovalTypes.Approved} />
            <LargeTab label={t('admin:removed')} value={ContentApprovalTypes.Removed} />
          </Tabs>
        </Grid>

        <Grid item xs>
          <Grid container alignItems="center" justify="flex-end" spacing={3}>
            <Grid item>{hasChecked ? actions : renderSearch()}</Grid>
          </Grid>
        </Grid>
        <Grid item />
      </Grid>
    </div>
  );
};

export default TableHeader;
